import { Delete, Get, Post, Put } from '../..';
import { ServiceRegionType } from '../../../type';
import { AppURL, getRegionalURL } from '../../../utility/AppURL';

export const getThreatNotificationList = async (region: ServiceRegionType, token: string) => {
    const headers = {
        'as-token': token,
        accept: 'application/json',
    };
    const response = await Get(getRegionalURL(AppURL.threatNotification, region), null, headers)
        .then((res) => res.json())
        .catch(() => {});
    return response;
};

export const getThreatNotification = async (region: ServiceRegionType, token: string, id: string) => {  
    const headers = {
        'as-token': token,
        accept: 'application/json',
    };
    const response = await Get(getRegionalURL(AppURL.threatNotification, region) + `/${id}`, null, headers)
        .then((res) => res.json())
        .catch(() => {});
    return response;
};

export const getThreatNotificationConditions = async (region: ServiceRegionType, token: string) => {
    const headers = {
        'as-token': token,
        accept: 'application/json',
    };
    const response = await Get(getRegionalURL(AppURL.threatNotificationConditions, region), null, headers)
        .then((res) => res.json())
        .catch(() => {});
    return response;
};

export const createThreatNotification = async (region: ServiceRegionType, token: string, data: any) => {
    const headers = {
        'as-token': token,
        'Content-Type': 'application/json',
    };
    const response = await Post(getRegionalURL(AppURL.threatNotification, region), data, headers)
        .then((res) => res.json())
        .catch(() => {});
    return response;
};

export const updateThreatNotification = async (region: ServiceRegionType, token: string, data: any, id: string) => {
    const headers = {
        'as-token': token,
        'Content-Type': 'application/json',
    };
    const response = await Put(getRegionalURL(AppURL.threatNotification, region) + `/${id}`, data, headers)
        .then((res) => res.json())
        .catch(() => {});
    return response;
};

export const deleteThreatNotification = async (region: ServiceRegionType, token: string, id: string) => {
    const headers = {
        'as-token': token,
        'Content-Type': 'application/json',
    };
    const response = await Delete(getRegionalURL(AppURL.threatNotification, region) + `/${id}`, null, headers)
        .then((res) => res.json())
        .catch(() => {});
    return response;
};

export const toggleThreatNotification = async (region: ServiceRegionType, token: string, id: string, active: boolean) => {
    const headers = {
        'as-token': token,
        'Content-Type': 'application/json',
    };
    const status = active ? 'active' : 'inactive';
    const response = await Put(getRegionalURL(AppURL.threatNotification, region) + `/${id}/${status}`, null, headers)
        .then((res) => res.json())
        .catch(() => {});
    return response;
};